import { Map, Table2 } from "lucide-react";
import { cn } from "@/lib/utils";

export type ViewMode = "map" | "table";

export function ViewToggle({ value, onChange }: { value: ViewMode; onChange: (v: ViewMode) => void }) {
  const base = "inline-flex h-8 items-center gap-1.5 px-2.5 text-[13px] transition-colors";
  return (
    <div role="group" aria-label="View" className="inline-flex h-8 overflow-hidden rounded-sm border border-foreground">
      <button type="button" aria-pressed={value === "map"} onClick={() => onChange("map")}
        className={cn(base, value === "map" ? "bg-foreground text-background" : "hover:bg-accent")}>
        <Map className="size-3.5" aria-hidden /> Map
      </button>
      <button type="button" aria-pressed={value === "table"} onClick={() => onChange("table")}
        className={cn(base, value === "table" ? "bg-foreground text-background" : "hover:bg-accent")}>
        <Table2 className="size-3.5" aria-hidden /> Table
      </button>
    </div>
  );
}
